import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "daab7950-c155-4097-b2fb-d3d242847f53", content: "Double-pane or triple pane design", options: {} },
  { id: "0cf9b8fa-62f9-4276-acd1-6918de342d3c", content: "Tight, sealed fit to the window frame", options: {} },
  { id: "bad0e590-0fd5-48bb-9910-9c2ed9f22a61", content: "Retrofitted double-casement design", options: {} },
  { id: "01c2ead2-50a3-45a5-b52c-22f99f7f7de7", content: "Strict installation procedures", options: {} },
  {
    id: "46b0a820-8ca4-4287-ad31-cdd9aa37c279",
    content: "The same width of both airgaps in triple-pane design",
    options: {},
  },
  {
    id: "547d136d-ed0f-4f52-80a8-a8b9907f93c9",
    content: "The same thickness of all panes in double- or triple-pane design",
    options: {},
  },
  { id: "c8e85fa7-39e0-497b-bbea-c9985c1ce38c", content: "Low total surface mass", options: {} },
  { id: "f007d702-e9ef-47b2-8f4e-67a37ef08e38", content: "Thin, ordinary single-pane design", options: {} },
];

const groups = [
  { id: "285b32e5-65f8-4cee-bf86-bc01d4dba405", content: "Good sound insulation", options: {} },
  { id: "23184c49-432d-489f-8e09-2d69ed7b4ec8", content: "Bad sound insulation", options: {} },
];

export const task: Task = {
  id: "10ced114-cf63-4756-bcbe-3e6cd55c023a",
  solutionType: "group",
  type: "categorizeLabels",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "285b32e5-65f8-4cee-bf86-bc01d4dba405",
      itemsId: [
        "daab7950-c155-4097-b2fb-d3d242847f53",
        "0cf9b8fa-62f9-4276-acd1-6918de342d3c",
        "bad0e590-0fd5-48bb-9910-9c2ed9f22a61",
        "01c2ead2-50a3-45a5-b52c-22f99f7f7de7",
      ],
    },
    {
      groupId: "23184c49-432d-489f-8e09-2d69ed7b4ec8",
      itemsId: [
        "46b0a820-8ca4-4287-ad31-cdd9aa37c279",
        "547d136d-ed0f-4f52-80a8-a8b9907f93c9",
        "c8e85fa7-39e0-497b-bbea-c9985c1ce38c",
        "f007d702-e9ef-47b2-8f4e-67a37ef08e38",
      ],
    },
  ],
};
